
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"29.5","height":"29.5"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a","x":"0","y":"0","width":"29.5","height":"29.5","filterUnits":"userSpaceOnUse"}},[_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"2.5","result":"blur"}}),_c('feFlood',{attrs:{"flood-color":"#fff"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"data-name":"sun"}},[_c('g',{attrs:{"filter":"url(#a)"}},[_c('path',{attrs:{"data-name":"Vector","d":"M21.25 14.75a6.5 6.5 0 11-6.5-6.5 6.5 6.5 0 016.5 6.5z","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})]),_c('path',{attrs:{"data-name":"Vector","d":"M21.76 7.74l.13-.13zM7.61 21.89l.13-.13zm7.14-17.06h0zm0 19.92h0zm-9.92-10h0zm19.92 0h0zM7.74 7.74l-.13-.13zm14.15 14.15l-.13-.13","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])
          )
        }
      }
    